module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/crocodile-pic.24247602.png";